import { GridInitialState, GridState } from "@mui/x-data-grid-pro";
import { DEFAULT_PAGINATION_MODEL } from "src/components/common/dataGrid/utils";
import { setLocalStorageItemManaged } from "src/storage/localStorageUtils.ts";
import { DeepPartial } from "react-hook-form";

export interface DataGridPersistStateProps {
	onStateChange: (state: DeepPartial<GridState>) => void;
	initialState: GridInitialState;
	gridId: string;
}

export const dataGridPersistentStateProps = (
	gridId: string,
	initialState: GridInitialState = DEFAULT_GRID_INITIAL_STATE,
): DataGridPersistStateProps => {
	return {
		onStateChange: (state: DeepPartial<GridState>) => saveDataGridState(gridId, state),
		initialState: getStoredDataGridState(gridId, initialState),
		gridId: gridId,
	};
};

const saveDataGridState = (gridId: string, state: DeepPartial<GridState>) => {
	if (gridId === undefined) return;
	const toSave = {
		...state,
		rows: undefined,
		rowsMeta: undefined,
		detailPanel: undefined,
		sorting: {
			...state.sorting,
			sortedRows: undefined,
		},
	};
	setLocalStorageItemManaged(getStoredStateKey(gridId), JSON.stringify(toSave));
};

export const getStoredDataGridState = (
	gridId: string | undefined,
	defaultState: GridInitialState = DEFAULT_GRID_INITIAL_STATE,
) => {
	if (gridId === undefined) return defaultState;

	const savedState = localStorage.getItem(getStoredStateKey(gridId));
	if (savedState === null) return defaultState;

	return {
		...JSON.parse(savedState),
		density: undefined, // Migration from V6 to V7 broke the density setting, old values are not valid anymore
	};
};

const getStoredStateKey = (gridId: string) => {
	return `data-grid-state--${gridId}`;
};

export const DEFAULT_GRID_INITIAL_STATE: GridInitialState = {
	pagination: { paginationModel: DEFAULT_PAGINATION_MODEL },
};
